import { useState, useEffect } from "react";
import {
  useStripe,
  useElements,
  LinkAuthenticationElement,
  PaymentElement,
  AddressElement,
} from "@stripe/react-stripe-js";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import "./Stripe.css";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";
import { useSelector, useDispatch } from "react-redux";
import { getUser } from "./../../../utils/redux/slices/userSlice";
import { Button } from "../../ui/button";
import Spinner from "../spinner/spinner";

export default function CheckoutForm({
  setSuccessPayment,
  setPaymentInfo,
  setStartCall,
  setTypeCreditCard,
}) {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [referrer, setReferrer] = useState("");

  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const actualTokenLocal = localStorage.getItem("token");
    if (actualTokenLocal) {
      dispatch(getUser(actualTokenLocal));
    }
  }, []);

  useEffect(() => {
    // Trova il campo "Full Name" e nascondilo
    const fullNameInput = document.querySelector(
      ".StripeElement-addressName input"
    );

    if (fullNameInput) {
      fullNameInput.style.display = "none";
    }
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const referrerValue = queryParams.get("referrer");

    if (referrerValue) {
      setReferrer(referrerValue);
    }
  }, [location.search]);

  const handleSubmitStripe = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsProcessing(true);

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        // return_url: `${window.location.origin}/wizard/completion`,
      },
      redirect: "if_required",
    });

    if (
      error &&
      (error.type === "card_error" || error.type === "validation_error")
    ) {
      setMessage(error.message);
    } else if (paymentIntent && paymentIntent.status === "succeeded") {
      // setMessage("PaymentStatus: " + paymentIntent.status + "🎉");
      setPaymentInfo(paymentIntent);
      setStartCall(true);
      setTypeCreditCard("stripe");
    } else {
      setMessage("An unexpected error occured.");
    }

    // setIsProcessing(false);
  };

  return (
    <form id="payment-form" onSubmit={handleSubmitStripe}>
      <PaymentElement
        id="payment-element"
        // options={{
        //   billingDetails: {
        //     tax_id: "required",
        //     phone: "required",
        //     vat_number: "required",
        //   },
        // }}
      />
      <div style={{ visibility: "hidden" }}>
        <label className="label-Input-form">Optional Sales</label>
        <input value={referrer} />
      </div>
      <Button
        disabled={isProcessing || !stripe || !elements}
        id="submit"
        type="submit"
      >
        {isProcessing ? (
          <>
            <div className="flex justify-center items-center h-full">
              <span id="button-text">Processing ...</span>
              <span className="mx-4 mt-1">
                <Spinner size="20px" />
              </span>
            </div>
          </>
        ) : (
          <>
            <span id="button-text">Pay now</span>
          </>
        )}
      </Button>
      {/* Show any error or success messages */}
      {message && <div id="payment-message">{message}</div>}
    </form>
  );
}
